export default [
  {
    title: 'main_menu.dashboard',
    customIcon: 'DashboardIcon',
    path: '/analytics/dashboard',
    children: [],
  },
];
